import interceptorAxios from './InterceptorAxios';

const ServicioCfdi ={

    paginacion(objeto){
        return interceptorAxios.post('/cfdi/paginacion.json',objeto );
    },
    procesarCfdis(objeto){
       return interceptorAxios.post("/cfdi/procesar.json", objeto); 
    },
    guardarFirmaDigital(objeto){
        return interceptorAxios.post("/cfdi/guardar_firma_digital.json", objeto); 
     },
     paginacionAdmin(objeto){
        return interceptorAxios.post('/cfdi/paginacion_admin.json',objeto );
    }
}

export default ServicioCfdi;